/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Weekday_6Inputs */

const vi_irrigation_weekday_6 = /** @type {(inputs: Irrigation_Weekday_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T7`)
};

/**

* @param {Irrigation_Weekday_6Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_weekday_6 = /** @type {((inputs?: Irrigation_Weekday_6Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Weekday_6Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_weekday_6(inputs)
});